export const csvFileUploadRequests = {
  list: { lazy: () => import('./CsvFileUploadRequests'), component: 'CsvFileUploadRequestList' },
}

export const csvFileUploadLogs = {
  list: { lazy: () => import('./CsvFileUploadLogs'), component: 'CsvFileUploadLogList' },
}
